import React from "react";

function Loader() {
  return (
    <div className="flex w-full  items-center justify-center">
      <div className="loader text-center"></div>
    </div>
  );
}

export default Loader;
